import { render, staticRenderFns } from "./KeyValueLabel.vue?vue&type=template&id=a70500e8&"
import script from "./KeyValueLabel.vue?vue&type=script&lang=js&"
export * from "./KeyValueLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports